import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ReactTitle } from "react-meta-tags";
import * as yup from "yup";

import { CatalogProvider } from "hooks/useCatalog";
import { CatalogDetailProvider } from "hooks/useCatalogDetail";
import CustomPanel from "./CustomPanel";
import PanelDetail from "./PanelDetail";
import PanelList from "./PanelList";
import SuggestedPanel from "./SuggestedPanel";

export const validationSchema = yup.object({
  panelName: yup
    .string()
    .max(30, "The custom panel name may have a maximum of 30 characters.")
    .matches(
      /^[a-z0-9\s]+$/i,
      "Name required (max 30 characters and alphanumerical)"
    )
    .required("Name required (max 30 characters and alphanumerical)"),
  msi: yup.boolean(),
  snpId: yup.boolean(),
});

const EvaluatePanelOptions = (props: any) => {
  const { path } = useRouteMatch();

  return (
    <CatalogProvider>
      <CatalogDetailProvider>
        <ReactTitle title="Assay Marketplace Evaluate Panel Options: View Target Matches" />
        <Switch>
          <Route exact path={path}>
            <PanelList {...props} />
          </Route>
          <Route exact path={`${path}/catalog-panel-detail/:id`}>
            <PanelDetail key="catalog-panel-detail" {...props} />
          </Route>
          <Route exact path={`${path}/catalog-panel-customize/:id`}>
            <PanelDetail key="catalog-panel-customize" customize {...props} />
          </Route>
          <Route exact path={`${path}/custom-panel-detail/:id`}>
            <CustomPanel key="custom-panel-detail" {...props} />
          </Route>
          <Route exact path={`${path}/custom-panel-customize/:id`}>
            <CustomPanel key="custom-panel-customize" customize {...props} />
          </Route>
          <Route exact path={`${path}/suggested-panel-detail`}>
            <SuggestedPanel key="suggested-panel-detail" {...props} />
          </Route>
          <Route exact path={`${path}/suggested-panel-customize`}>
            <SuggestedPanel
              key="suggested-panel-customize"
              customize
              {...props}
            />
          </Route>
          <Redirect to={path} />
        </Switch>
      </CatalogDetailProvider>
    </CatalogProvider>
  );
};

export default EvaluatePanelOptions;
